export default __webpack_public_path__ + "img/send-gmail.2fa8071c.svg";